import { tsr } from '@/libs/ts-rest/ts-rest';

import { JobQueryKeys } from '../query-keys';

// TODO Optimize query invalidation
export const useJobMutations = () => {
	const queryClient = tsr.useQueryClient();
	const invalidateQuery = () => queryClient.invalidateQueries({ queryKey: JobQueryKeys.root() });

	const saveJobMutation = tsr.jobs.favorite.save.useMutation({ onSuccess: invalidateQuery });
	const removeJobMutation = tsr.jobs.favorite.remove.useMutation({ onSuccess: invalidateQuery });
	const jobApplicationMutation = tsr.jobs.apply.useMutation(({ onSuccess: invalidateQuery }));

	return {
		jobApplicationMutation,
		removeJobMutation,
		saveJobMutation,
	};
};
